import { parsePhoneNumber, formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

export const FormatPhoneNumber = (value: string) => {
    let phoneNumber = parsePhoneNumber(value);
    
    if (phoneNumber !== null && phoneNumber !== undefined) {
        if (phoneNumber.country === 'US') {
            return formatPhoneNumber(value).toString();
        }
        else
        {
            return formatPhoneNumberIntl(value).toString();
        }
    }
}